import "./App.css";

function App() {
  return (
    <div className="app-shell">
      <header className="hero">
        <img 
          src="/uploads/hero.jpg" 
          alt="Hero banner for Reston Cannabis, showcasing a variety of cannabis products" 
          style={{ 
            width: '100%', 
            maxHeight: '400px', 
            objectFit: 'cover' 
          }} 
        />
        <p className="eyebrow">Skighnet · Amplify Gen 2</p>
        <h1>Welcome to Reston Cannabis News</h1>
        <p className="lede">
          Your go-to source for the latest updates on cannabis policy, culture, and legal status in Reston. 
          Stay informed with our comprehensive coverage and educational resources.
        </p>
        <div className="cta-row">
          <a href="/latest-updates" target="_self">
            Explore Latest Updates
          </a>
          <a href="/educational-resources" target="_self" className="secondary">
            Access Educational Resources
          </a>
        </div>
      </header>

      <section className="cards">
        <article>
          <h2>Local Cannabis Law Updates</h2>
          <p>
            Stay informed about the latest changes in cannabis legislation and policy in Reston. 
            Our coverage provides insights into local regulations and their implications for residents.
          </p>
        </article>
        <article>
          <h2>Understanding Legal Status</h2>
          <p>
            Get clear information on the legal status of cannabis in your area. We break down the laws 
            and what they mean for you as a member of the community.
          </p>
        </article>
        <article>
          <h2>Educational Content</h2>
          <p>
            Explore our resources designed to educate the public about cannabis culture, health benefits, 
            and responsible use. Knowledge is key to informed decision-making.
          </p>
        </article>
      </section>
    </div>
  );
}

export default App;